export enum UPDATE_STATE {
  NONE = 'NONE',
  AVAILABLE = 'AVAILABLE',
  PENDING = 'PENDING',
  PROGRESS = 'PROGRESS',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  REQUESTED = 'REQUESTED',
}

